// 필터 관련 함수가 존재하는 파일
export function formatDate1(value) {
	const date = new Date(value);
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month > 9 ? month : `0${month}`;
	let day = date.getDate();
	day = day > 9 ? day : `0${day}`;
	let hours = date.getHours();
	hours = hours > 9 ? hours : `0${hours}`;
	let minutes = date.getMinutes();
	minutes = minutes > 9 ? minutes : `0${minutes}`;
	return `${year}년 ${month}월 ${day}일  ${hours}:${minutes}`;
}

export function formatDate2(value) {
	const date = new Date(value);
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month > 9 ? month : `0${month}`;
	let day = date.getDate();
	day = day > 9 ? day : `0${day}`;
	return `${year}.${month}.${day}`;
}

export function formatDate3(value) {
	const date = new Date(value);
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month > 9 ? month : `0${month}`;
	let day = date.getDate();
	day = day > 9 ? day : `0${day}`;
	let hours = date.getHours();
	hours = hours > 9 ? hours : `0${hours}`;
	let minutes = date.getMinutes();
	minutes = minutes > 9 ? minutes : `0${minutes}`;
	return `${year}.${month}.${day} ${hours}:${minutes}`;
}
